import { Divider } from "@/components/shared/divider";
import { View } from "@/components/ui";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";
import { Typography } from "@/components/shared/typography";
import { type ServiceProfileFormScreenProps } from "../lib";
import { BottomActions } from "@/components/shared/bottom-actions";
import { useMemo } from "react";
import { IconButton } from "@/components/ui/icon-button";
import { useRoute } from "@/components/shared/router";

export const ServiceProfileFormScreen = ({
  pageTitle,
  children,
  actions,
}: ServiceProfileFormScreenProps) => {
  const { isMobile } = useWindowDimensions();
  const { pull } = useRoute();

  const renderActions = useMemo(() => {
    if (isMobile) {
      return <BottomActions>{actions}</BottomActions>;
    }
    return actions;
  }, [actions, isMobile]);

  return (
    <View>
      <View className="flex flex-row items-center gap-2 p-4 md:mb-4 md:p-0">
        <IconButton
          variant={isMobile ? "ghost" : "secondary"}
          color="foreground"
          iconName="arrowLeft"
          rounded="full"
          className="p-0 md:px-3 md:py-2"
          onClick={pull}
        />

        <Typography variant="label-md">{pageTitle}</Typography>
      </View>
      <Divider />
      {children}
      {renderActions}
    </View>
  );
};
